module.exports = __webpack_public_path__ + "static/media/icons-guest-double.a25f26da.svg";